<script context="module" lang="ts">
    import type { Load } from '@sveltejs/kit';

    export const load: Load = async ({ stuff }) => {
        const query = await stuff.cms.aboutStudioSh();
        return {
            props: { query: query.entry },
        };
    };
</script>

<script lang="ts">
    import type { AboutStudioShQuery } from '$gen/graphql';
    import SeoMetaTags from '$lib/components/SeoMetaTags.svelte';

    type AboutStudioShContent = Extract<
        AboutStudioShQuery['entry'],
        { __typename: 'aboutStudioSh_aboutStudioSh_Entry' }
    >;

    export let query: AboutStudioShContent;

    $: content =
        query &&
        query.aboutStudioSh.length > 0 &&
        query.aboutStudioSh[0].__typename === 'aboutStudioSh_BlockType'
            ? query.aboutStudioSh[0]
            : null;

    function checkIfEmailInString(text) {
        var re =
            /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
        return re.test(text);
    }
</script>

<SeoMetaTags seo={query?.seo} />

<div
    class="grid min-h-screen grid-cols-gridWithAside py-20 text-xl leading-5 md:text-2xl md:leading-6"
>
    {#if content}
        <div id="main-container" class="space-y-5">
            <section id="intro-text" class="mb-16">
                {@html content.intoText}
            </section>
            <section>
                {#each content.contactDesignStudio as { text }, i}
                    {#if i === 0}
                        <h2>{text}</h2>
                    {:else if checkIfEmailInString(text)}
                        <a href={`mailto:${text}`} class="ml-5 block text-blue">{text}</a>
                    {:else}
                        <span class="ml-5 block">{text}</span>
                    {/if}
                {/each}
            </section>
            <section>
                {#each content.contactEditorial as { text }, i}
                    {#if i === 0}
                        <h2>{text}</h2>
                    {:else if checkIfEmailInString(text)}
                        <a href={`mailto:${text}`} class="ml-5 block text-blue">{text}</a>
                    {:else}
                        <span class="ml-5 block">{text}</span>
                    {/if}
                {/each}
            </section>
            <section>
                <h2>{content.socialMediaHeading}</h2>

                <ul class="ml-5 flex flex-row space-x-2">
                    {#each content.socialMediaEntries as { text, link }, i}
                        <li><a href={link} class="block text-blue">{text}</a></li>
                    {/each}
                </ul>
            </section>
        </div>
    {/if}
</div>

<style>
    #main-container {
        grid-column: main;
    }

    #intro-text > :global(p + p) {
        @apply mt-5;
    }
</style>
